import AxiosInstance from "../Axios"
import { ResourceFile, ResourceType } from "./Interfaces"

/** Bread and butter function for getting the resources by type */
export async function get_resources_by_type(type: ResourceType): Promise<ResourceFile[]> {
    console.log("Getting resources by type: ", type)
    const response = await AxiosInstance.get(`/api/afs/resource-list/${type}`)

    console.log("Resources: ", response.data)

    return response.data.resources
}

// Upload a resource to the database
// Places the file depending on the type
// Other metadata like who uploaded it, when it was uploaded is done on the backend
// Type is the type of the resource to upload (resources, electrical, mechanical, plumbing, fire protection, cad, help)
export async function upload_resource(file: File, type: string, name: string): Promise<ResourceFile> {
    console.log("Uploading resource: ", file, type, name)
    const formData = new FormData()
    formData.append("file", file)
    formData.append("type", type)
    formData.append("name", name)

    const response = await AxiosInstance.post(`/api/afs/upload-resource`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        timeout: 0,
    })
    return response.data
}

export async function delete_resource(fileName: string, type: ResourceType): Promise<void> {
    console.log("Deleting resource: ", fileName, type)
    await AxiosInstance.delete(`/api/afs/delete-resource`, {
        data: {
            file_name: fileName,
            type: type
        }
    })
}

export type VideoStreamResponse = {
    success: boolean
    video_url: string
    expires_at: string
}

// Stream a video from the Azure File Share
export async function stream_video(file_name: string, location: string = "resources"): Promise<VideoStreamResponse> {
    const response = await AxiosInstance.post(`/api/afs/video-stream`, {
        file_name,
        location
    })
    return response.data
}

// Update resource metadata (including description)
export async function update_resource_metadata(
    fileName: string, 
    type: ResourceType, 
    description: string, 
    additionalMetadata?: Record<string, string>
): Promise<void> {
    console.log("Updating resource metadata: ", fileName, type, description)
    await AxiosInstance.post(`/api/afs/update-resource-metadata`, {
        file_name: fileName,
        type: type,
        description: description,
        metadata: additionalMetadata || {}
    })
}

// Download/open a resource file with proper authentication
export async function open_resource_file(fileName: string, type: ResourceType): Promise<void> {
    console.log("Opening resource file: ", fileName, type)
    try {
        const response = await AxiosInstance.get(`/api/afs/serve-resource/${type}/${fileName}`, {
            responseType: 'blob'
        })
        
        // Create blob URL and open in new tab
        const blob = new Blob([response.data])
        const url = window.URL.createObjectURL(blob)
        window.open(url, '_blank')
        
        // Clean up the blob URL after a short delay
        setTimeout(() => window.URL.revokeObjectURL(url), 1000)
    } catch (error) {
        console.error('Failed to open resource file:', error)
        throw error
    }
}